/**
 * Return the results of getAnswers but sorted by created date descending.
 */

import { createSelector } from 'reselect';

import type { BasketItem } from '/business/shared/state/reducers/basket';
import getAnswers from './getAnswers';

export default createSelector(getAnswers, (answers) =>
  [...answers].sort((a: BasketItem, b: BasketItem) => {
    const createdA = a.created ? new Date(a.created).getTime() : 0;
    const createdB = b.created ? new Date(b.created).getTime() : 0;
    return createdB - createdA;
  }),
);
